import React from 'react';
import ReactDOM from 'react-dom';

interface PortalLoaderProps {
  dataAttr: string;
  Component: any;
}

const PortalLoader = (props: PortalLoaderProps): React.ReactPortal => {
  const { dataAttr, Component } = props;
  const domNode: HTMLElement = document.querySelector(`[${dataAttr}]`);
  if (!domNode) return null;

  // Clear the content
  // domNode.innerHTML = '';
  return ReactDOM.createPortal(<Component
    dataSet={domNode.dataset}
  />, domNode);
}

export default PortalLoader;